<div class="main-container">
    <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(false);$event.stopPropagation()">
    <span class="generic-title">{{config.title.key | translate}}</span>
    <span class="generic-description" [innerHTML]="(config.description.key | translate: config.description.params)"></span>
    <div class="buttons-container">
        <button pButton [ngClass]="button.className" [label]="(button.labelKey | translate)" *ngFor="let button of config.buttons" (click)="close(button.value)"></button>
    </div>
</div>